import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { Product, ProductEnum } from '@uc/shared/data-models';
import { RouterLink } from '@angular/router';
import { OfficeSvgComponent } from '@uc/shared/svg';
import { UniProfileGAEventDirective } from '@uc/web/analytics';

@Component({
	selector: 'uc-header-title',
	templateUrl: './header-title.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [OfficeSvgComponent, RouterLink, UniProfileGAEventDirective],
})
export class HeaderTitleComponent {
	product = input.required<Product>();
	courseName = input.required<string>();
	uniName = input.required<string>();
	uniSlug = input.required<string>();
	uniId = input.required<number>();
	searchOrderPosition = input<number | null>(null);

	link = computed(() => {
		const baseLink = `/universities/${this.uniSlug()}`;

		return this.product() === ProductEnum.Undergraduate
			? baseLink
			: `${baseLink}/${this.product()}`;
	});

	ugso = computed(() =>
		this.product() === ProductEnum.Undergraduate ? this.searchOrderPosition() : null,
	);

	cleso = computed(() =>
		this.product() === ProductEnum.Clearing ? this.searchOrderPosition() : null,
	);
}
